import  { usersLogin } from '@/services/user';
import { router } from '@/router';
import { code } from '@/utils/website-data';
import { deleteURLParams } from '@/utils/query-string';
import XEventSource from '@/utils/x-eventsource';

const user = {
  state: {
    userInfo: {},
    regInfo: {},
    bgImg:'',
    isShowSend: false,
    isInsidSignUp:false,
    isUserDiaLog:{
      isShowDiaLog:false,
      currentVal:'login'
    },
    refreshState:{
      type:'',
      flag:false
    },
    isRegDiaLog:false,
    isNoticeState:false,
    isSerialDiaLog:false, //序列赛注册弹窗
    serialType:'1' // 序列赛=> 1注册 2报名
  },
  
  getters: {
    loginStatus(state) {
      return (
        state.userInfo &&
        (state.userInfo.token || state.userInfo.accessToken)
      );
    },
  },
 
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    REG_INFO(state, payload) {
      state.regInfo = payload
    },
    SAVE_BGURL(state, payload) {
      state.bgImg = payload
    },
    SET_SEND(state, payload) {
      state.isShowSend = payload;
    },
    AET_INSID_SIGN_Up(state, payload) {
      state.isInsidSignUp = payload
    },
    SET_USER_DIA_LOG(state, payload){
      state.isUserDiaLog = {...state.isUserDiaLog,...payload}
    },
    SET_REFRESH(state, payload){
      state.refreshState = payload
    },
    SET_REG_DIA_LOG(state, payload){
      state.isRegDiaLog = payload
    },
    SET_NOTICE_STATE(state,payload){
      state.isNoticeState = payload
    },
    SET_IS_SERIESDIALOG(state,playload){
      state.isSerialDiaLog = playload;
    },
    SET_SERIAL_TYPE(state,playload){
      state.serialType = playload;
    }
  },

  actions: {
    initUserInfo({ dispatch, rootGetters,rootState },playload) {
      const {xilieTokenKey,tokenKey} = rootGetters;
      const {isSerial, loginType} = rootState.router;
        let data;

        if((isSerial && loginType !== 1) || playload){
          try {
            data = JSON.parse(localStorage.getItem(xilieTokenKey)) || {};
          } catch (error) {
            data = {};
          }
        }else{
            try {
            data = JSON.parse(localStorage.getItem(tokenKey)) || {};
          } catch (error) {
            data = {};
          }
        }
        
        dispatch('saveUserInfo',data);
    },
    saveUserInfo({ commit, rootGetters,rootState }, params) {
      commit("SET_USER_INFO", params)
      // 如果是系列赛或者当前没有竞赛id(系列赛列表页) 撇开内部系列赛
      if((rootState.router.isSerial && rootState.router.loginType !== 1) || !rootState.router.id) {
        return localStorage.setItem(rootGetters.xilieTokenKey, JSON.stringify(params))
      }
      localStorage.setItem(rootGetters.tokenKey, JSON.stringify(params))
    },
    saveRegInfo({ commit }, payload) {
      commit('REG_INFO', payload)
    },
    // 登录
    async Login({ commit, rootGetters,rootState }, paramms) {
      const res = await usersLogin(paramms)
      commit("SET_USER_INFO", res.data)
      if((rootState.router.isSerial && rootState.router.loginType !== 1) || !rootState.router.id) { // 撇开内部系列赛
        return localStorage.setItem(rootGetters.xilieTokenKey, JSON.stringify(res.data))
      }
      localStorage.setItem(rootGetters.tokenKey, JSON.stringify(res.data))
    },

    // 登出
    LogOut({ commit, rootGetters, rootState}) {
      commit('SET_USER_INFO', {});
      if((rootState.router.isSerial && rootState.router.loginType !== 1) || !rootState.router.id) {
        commit('AET_INSID_SIGN_Up',false)
        commit('SET_SERIAL_TYPE','1')
        if(rootState.router.isSerial){
          router.replace({ path: '/' });
        }
        return localStorage.removeItem(rootGetters.xilieTokenKey)
      }
      localStorage.removeItem(rootGetters.tokenKey)

      router.replace({ path: '/' });
      commit('AET_INSID_SIGN_Up',false)
      if (code) {
        let url = deleteURLParams('code');
        window.location.href = url;
      }
    },
    setSmsSend({
      commit
    }, payload) {
      commit('SET_SEND', payload)
    },
    // 内部竞赛报名成功
    setInsidSignUp({
        commit,
      }, payload) {
      commit('AET_INSID_SIGN_Up', payload);
    },
    setUserDiaLog({commit},payload){
      commit('SET_USER_DIA_LOG', payload);
    },
    setRefresh({commit},payload){
      commit('SET_REFRESH', payload);
    },
    setRegDiaLog({commit},payload){
      commit('SET_REG_DIA_LOG', payload);
    },
    setNoticeState({commit},payload){
      commit('SET_NOTICE_STATE',payload)
    },
    golbalNotice({state,dispatch},competitionId){
      if(xeventsource) xeventsource.abort();
      let xeventsource = null;
      xeventsource = new XEventSource(`${process.env.VUE_APP_URL}/api/competition/sse/stu/update/${competitionId}/`);
      xeventsource.on('message', (resp) => {
        try {
          let data = JSON.parse(resp.data);
          if (data) {
            if(!state.isNoticeState) dispatch('setNoticeState',true)
            xeventsource.destroy();
            return;
          }
        } catch (err) {
          dispatch('setNoticeState',false)
          xeventsource.abort();
        }
      })
      xeventsource.on('close', () => {
        xeventsource.abort();
        dispatch('setNoticeState',false)
      });
      xeventsource.on('error', () => {
        xeventsource.destroy();
        dispatch('setNoticeState',false)
      });
    },
    setIsSerialDiaLog({commit},payload){
      commit('SET_IS_SERIESDIALOG',payload)
    },
    setSerialType({commit},payload){
      commit('SET_SERIAL_TYPE',payload)
    }
  }
}

export default user
